import React from "react";
import { Link } from "react-router-dom";
import images from "../assets/images";
import "./Welcome.css";

const Welcome: React.FC = () => {
  return (
    <div className="welcome-container">
      <main className="welcome-card">
        <section className="welcome-header">
          <h1 className="welcome-title">Converii</h1>
          <p className="welcome-subtitle">
            Empowering connectors to have a positive impact.
          </p>
          <p className="welcome-subtitle welcome-subtitle--secondary">
            Your foundation for delivering the gatherings the world needs.
          </p>
        </section>

        <section className="welcome-body">
          <div className="welcome-message">
            <h3 className="welcome-message__title">
              Welcome to <span>your opportunity</span> to co-create a platform
              that will help you:
            </h3>
            <ul className="welcome-list">
              <li className="welcome-list__item">
                <div className="welcome-list__content">
                  <h4 className="welcome-list__heading">
                    Build a credible action list
                  </h4>
                  <p className="welcome-list__text">
                    Create a list of credible actions so you can demonstrate real progress
                    towards the Paris Agreement.
                  </p>
                  <p className="welcome-list__meta">
                    Also helps you evidence Race to Zero criteria, ISO 20121, B Corp and more.
                  </p>
                </div>
              </li>

              <li className="welcome-list__item">
                <div className="welcome-list__content">
                  <h4 className="welcome-list__heading">
                    Tailor actions to your event
                  </h4>
                  <p className="welcome-list__text">
                    Adapt your actions to your specific event, product, or service – whether
                    you’re a venue, organiser, or part of the event supply chain.
                  </p>
                </div>
              </li>

              <li className="welcome-list__item">
                <div className="welcome-list__content">
                  <h4 className="welcome-list__heading">
                    Turn intent into action
                  </h4>
                  <p className="welcome-list__text">
                    Access credible resources that support you in moving from a list of ideas
                    to tangible, trackable action.
                  </p>
                </div>
              </li>
            </ul>

          </div>

          <div className="account-actions">
            <h2 className="account-actions__title">Get started</h2>
            <p className="account-actions__subtitle">
              Already part of the journey? Sign in to continue. New here? Create
              an account to explore and contribute.
            </p>

            <div className="account-actions__buttons">
              <Link
                to="/login"
                className="welcome-button welcome-button--primary"
              >
                Login
              </Link>
              <Link
                to="/register"
                className="welcome-button welcome-button--secondary"
              >
                Register
              </Link>
            </div>

            <p className="friendly-warning">
              Please be aware: you’re joining a community co-creating this
              platform. What you see next may not look perfect and might have
              glitches — but it is the perfect place for you to get involved.
            </p>
          </div>
        </section>

        <section className="brand-strip">
          <div className="brand-strip__inner">
            <div className="brand-logo">
              <img
                src={images.rtzLogo}
                className="brand-logo__image"
                alt="RTZ Logo"
              />
            </div>
            <div className="brand-logo">
              <img
                src={images.piLogo}
                className="brand-logo__image"
                alt="PI Logo"
              />
            </div>
            <div className="brand-logo">
              <img
                src={images.rtzAcceleratorLogo}
                className="brand-logo__image"
                alt="RTZ Accelerator Logo"
              />
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Welcome;
